import React, { FC } from "react";
import { Button, Form, Modal, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import { ReportFormProps } from "./ReportForm";
import ContactOptions, { ContactChoices, FormOption } from "./ContactOptions";
import axios from "axios";

const SuggestionForm: FC<ReportFormProps> = ({showModal, handleShowModal, handleSubmitResponse, SESSION_INFO}) => {
    const [show, setShow] = useState(showModal);
    const [suggestion, setSuggestion] = useState("");
    const [contactChoice, setContactChoice] = useState(ContactChoices.Email);
    const [contactInfo, setContactInfo] = useState(SESSION_INFO.user.email);
    const [errors, setErrors] = useState({});
    const [validationSuccess, setValidationSuccess] = useState(false);

    const handleClose = () => {
        setShow(false);
        handleShowModal();
    };

    const handleContactChoiceChange = (option: ContactChoices) => {
        setContactChoice(option);
        setErrors({...errors, email: '', phone: ''});
    };

    const handleContactInfoChange = (info: string) => {
        setContactInfo(info);
        setErrors({...errors, email: '', phone: ''});
    };

    const handleSuggestionChange = (suggestion: string) => {
        setSuggestion(suggestion);
        setErrors({...errors, suggestion: ''});
    }

    const URLsid = SESSION_INFO?.sid;

    const validate = () => {
        const newErrors = {};
        if (suggestion === "") {
          newErrors['suggestion'] = 'Suggestion is missing';
        }
        if (contactChoice === ContactChoices.Email && !contactInfo.includes('@')) {
            newErrors['email'] = 'Email is invalid';
        }
        if (contactChoice === ContactChoices.Email && contactInfo === "") {
            newErrors['email'] = 'Email is missing';
        }
        if (contactChoice === ContactChoices.Phone && contactInfo === "") {
            newErrors['phone'] = 'Phone is missing';
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setValidationSuccess(true);
            e.preventDefault();
            try {
                handleClose();
                const suggestionText = `<div><b>Preferred Contact Method:</b>&nbsp;${contactChoice}<br></div><ul><li>Email:&nbsp;${contactChoice === ContactChoices.Email ? contactInfo : ''}<br></li><li>Phone:&nbsp${contactChoice === ContactChoices.Phone ? contactInfo : ''};</li></ul><div><br></div><div></div><div><b>Suggestion:</b></div><div><b>​</b>${suggestion}<br></div><div><hr><div style=\"overflow: scroll\"><table style=\"font-size: 13px\"> <tbody><tr><td valign=\"top\">Name</td><td valign=\"top\">:</td><td valign=\"top\">${SESSION_INFO.user.firstname}, ${SESSION_INFO.user.lastname}</td></tr><tr><td valign=\"top\">Email</td><td valign=\"top\">:</td><td valign=\"top\">${SESSION_INFO.user.email}</td></tr><tr><td valign=\"top\">Share Suggestion</td><td valign=\"top\">:</td><td valign=\"top\">${suggestion}</td></tr><tr><td valign=\"top\">Upload Screenshot or Other Helpful Documents</td><td valign=\"top\">:</td><td valign=\"top\"></td></tr><tr><td valign=\"top\">Please contact me regarding my suggestion.</td><td valign=\"top\">:</td><td valign=\"top\">${contactChoice !== ContactChoices.None}</td></tr></tbody></table></div><br></div>`
                const response = await axios.post(
                    `/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/createZohoTicket?SessionID=${URLsid}`,
                    {
                        channel: "Web",
                        classification: "Feature Suggestion",
                        subject: 'Suggestion from ' + SESSION_INFO.user.fullname + ' at ' + SESSION_INFO.firm.name,
                        contact: {
                            email: SESSION_INFO.user.email,
                        },
                        cf: {
                            cf_product: SESSION_INFO.appCode,
                            cf_province: SESSION_INFO.appProvinceShort,
                            cf_client_requested_followup: contactChoice !== ContactChoices.None,
                        },
                        departmentId: "180615000004056051",
                        description: suggestionText,
                        email: SESSION_INFO.user.email,
                        status: "Open",
                    },
                );
                if  (response.status === 200) {
                    handleSubmitResponse(true);
                }
                console.log('Ticket created successfully:', response.data);
            } catch (error) {
                handleSubmitResponse(false);
                console.error('Error creating ticket:', error.response.data);
            }
        } else {
            setErrors(validationErrors);
            setValidationSuccess(false);
        }
    };

    return (
        <Modal show={show} centered onHide={handleClose} backdrop="static">
            <Modal.Header>
                <Modal.Title>Suggestion Box</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit} id="suggestForm">
                    <Form.Group controlId="userInfo">
                        <Row className="mb-3">
                            <Col>
                                <Form.Label className="fw-bold">First Name</Form.Label>
                                <Form.Control disabled value={SESSION_INFO.user.firstname}></Form.Control>
                            </Col>
                            <Col xs={6}>
                                <Form.Label className="fw-bold">Last Name</Form.Label>
                                <Form.Control disabled value={SESSION_INFO.user.lastname}></Form.Control>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="issues">
                                <Form.Label className="fw-bold">Describe your suggestion in the textbox below.<span className="required">*</span></Form.Label>
                                <Form.Control as="textarea" rows={5} onChange={(e) => handleSuggestionChange(e.target.value)}></Form.Control>
                                {!validationSuccess && <b className="input-error">{errors['suggestion']}</b>}
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* Temporarily hide the file uploader */}
                    {/* <FileUploader type={FileUploadType.Suggestion} fileType="image" multiple fileAccept="image/png, image/gif, image/jpeg" updateFile={setFiles} /> */}
                    <ContactOptions
                        initialEmail={SESSION_INFO.user.email}
                        formOption={FormOption.Suggestion}
                        updateContactChoice={handleContactChoiceChange}
                        updateContactInfo={handleContactInfoChange}
                        errorMsgs={errors}
                    />
                </Form>
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="link" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" type="submit" form="suggestForm">
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SuggestionForm;